import { useEffect, useRef } from 'react';
import type { DependencyList, EffectCallback } from 'react';

/** Как componentDidUpdate: эффект срабатывает на изменении deps, пропуская первый рендер. */
export default function useComponentDidUpdate(effect: EffectCallback, deps?: DependencyList) {
  const isInitialMount = useRef(true);

  // eslint-disable-next-line consistent-return
  return useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      return effect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
